module.exports = __webpack_public_path__ + "img/banner-pc.f3b79410.png";